import { Plus } from "lucide-react";

interface SelectOtherAgentCardProps {
  onClick: () => void;
}

export function SelectOtherAgentCard({ onClick }: SelectOtherAgentCardProps) {
  return (
    <div
      className="flex flex-col justify-center items-center gap-[32px] py-[40px] px-[24px] rounded-[8px] border border-[#00000017] hover:border-[#FF3B00]/50 hover:bg-[#FFF9F5] transition-all"
      onClick={onClick}
    >
      <div className="w-[80px] h-[80px] rounded-full bg-[#00000010] flex justify-center items-center">
        <Plus width={"26.67px"} height={"26.67px"} />
      </div>
      <div className="flex flex-col justify-center items-center gap-[12px]">
        <h3 className="text-[20px] font-bold text-[#202020]">
          다른 에이전트가 필요하신가요?
        </h3>
        <p className="max-w-[257px] text-center text-[16px] text-[#646464]">
          원하는 에이전트를 찾지 못하셨나요? 당신의 요구에 딱 맞는 맞춤형 AI
          에이전트를 요청해 보세요.
        </p>
      </div>
    </div>
  );
}
